module.exports = __webpack_public_path__ + "static/media/Megan Gardner Headshot_1736261124818.377712b5.jpeg";